import React from "react";
import Lottie from "lottie-react";
import responsiveAnimation from "../assets/animations/spaceShip.json";
import { Box, Flex, Input, Textarea, Button, Heading } from "@chakra-ui/react";
import Navbar from "../components/nav/index";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import ProfileImage from "../assets/icons/profile.png";

const Contact = () => {
  return (
    <Box
      backgroundColor={"#000000"}
      gap={20}
      minHeight={"100vh"}
      color={"gray.300"}
    >
      <FloatingWhatsApp
        phoneNumber="+923026402646"
        accountName="Moiz"
        chatMessage="Hello there! How can I help?"
        darkMode={true}
        avatar={ProfileImage}
        style={{ display: "block" }}
        buttonStyle={{ backgroundColor: "#34A9A7" }}
      />
      <Flex direction={"column"}>
        <Navbar />
        <Flex
          margin={{ base: 5, lg: 10, xl: 20 }}
          justifyContent={"space-between"}
          gap={5}
        >
          <Flex
            direction={"column"}
            top={50}
            bottom={0}
            left={{ base: 0, md: "47vw" }}
            right={0}
            gap={5}
            zIndex={0}
            position={"absolute"}
            opacity={0.15}
          >
            <Lottie
              cellPadding={0}
              animationData={responsiveAnimation}
              loop={true}
              autoplay={true}
              style={{ width: "100%", height: "100%" }}
              rendererSettings={{
                preserveAspectRatio: "xMidYMid slice",
              }}
            />
          </Flex>
          <Flex
            direction={"column"}
            width={{ base: "100%", md: "40%" }}
            gap={16}
            height={"100%"}
          >
            <Heading fontSize={"3xl"}>Contact Me</Heading>
            <Flex direction={"column"} borderRadius={"md"}>
              <div className="container">
                <form
                  target="_blank"
                  action="https://formsubmit.co/nafeymoiz@gmail.com"
                  method="POST"
                >
                  <Flex direction={"column"} gap={7}>
                    <Flex gap={3} justifyContent={"space-between"}>
                      <Input
                        type="text"
                        name="firstName"
                        className="form-control"
                        placeholder="First Name"
                        required
                        backgroundColor={"white"}
                        color={"black"}
                      />
                      <Input
                        backgroundColor={"white"}
                        color={"black"}
                        type="text"
                        name="lastName"
                        className="form-control"
                        placeholder="Last Name"
                        required
                      />
                    </Flex>
                    <Input
                      backgroundColor={"white"}
                      color={"black"}
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email Address"
                      required
                    />

                    <Textarea
                      backgroundColor={"white"}
                      color={"black"}
                      placeholder="Your Message"
                      className="form-control"
                      name="message"
                      rows="5"
                      required
                    ></Textarea>

                    <Button
                      type="submit"
                      backgroundColor={"#34A9A7"}
                      color={"gray.100"}
                      _hover={{
                        backgroundColor: "",
                        transform: "scale(1.07)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      Submit Form
                    </Button>
                    {/* <input
                      type="hidden"
                      name="_next"
                      value={`${window.location.host}/success`}
                    ></input> */}
                  </Flex>
                </form>
              </div>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Contact;
